const initPage = () => {
    const printApplicationBtns = $(".print-application");

    for (const printBtn of printApplicationBtns) {
        printBtn.addEventListener('click', printPage.bind(printBtn))
    }
};

const printPage = (data) => {
    const url = data.target.dataset.url;

    if (!url) {
       return;
    }

    const printWindow = window.open(url, '_blank');
    printWindow.onload = function() {
        printWindow.print();
        printWindow.onafterprint = function() {
            printWindow.close();
        }
    }
};

$(initPage);
